<template>
  <div class="comm_transaction_search">
    <div class="transaction_search">
      <div class="transaction_search_item">
        <span>{{ $t('title.RPC_service') }}:</span>
        <el-select v-model="envValue" :placeholder="this.$t('title.please_choose')" @change="rpcChange">
          <el-option
            v-for="item in envoptions"
            :key="item.id"
            :label="item.name"
            :value="item.rpcUrl"
          ></el-option>
        </el-select>
      </div>
      <div class="transaction_search_item">
        <span>{{ $t('title.address') }}:</span>
        <el-select style="width: 540px;" v-model="selectAddress" :placeholder="this.$t('title.please_choose')">
          <el-option
            v-for="item in addressOptions"
            :key="item.id"
            :label="`${item.nickname} - ${item.address}`"
            :value="item.address"
          ></el-option>
        </el-select>
      </div>
      <div class="transaction_search_item">
        <el-input style="width:370px;" v-model="inputAddress" :placeholder="this.$t('title.Select_or_enter_the_query_address')"></el-input>
      </div>
      <div class="transaction_search_item">
        <el-button :loading="loading" type="primary" @click="searchAddress">{{ $t('title.search') }}</el-button>
      </div>
    </div>
    <div class="transaction_table">
      <el-table
        :data="orderType != 1 ? tableData.slice( (currentPage-1)*pagesize, currentPage*pagesize) : tableData.slice( (myCurrentPage-2 < 0 ? 0 : ((myCurrentPage-2)*pagesize + beginRows)), (myCurrentPage-1)*pagesize + beginRows).reverse()"
        border
        style="width: 100%;margin-bottom: 30px;margin-top: 20px;min-height: 529px"
        :header-cell-style="tableHeaderColor"
        v-loading="loading"
      >
        <el-table-column :label="$t('title.Transaction_hash')" width="300" align="center" prop="tradingHash"></el-table-column>
        <el-table-column :label="$t('title.Timestamp')" width="190" align="center">
          <template slot-scope="scope">
            <span>{{timestampToTime(scope.row.timeStamp)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('title.organizer')" width="400" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.fromAddress}}</span>
            <br />
            <span>{{to_32_decimal(scope.row.from)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('title.receiver')" width="400" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.toAddress}}</span>
            <br />
            <span>{{to_32_decimal(scope.row.to)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('title.TransactionType')" width="90" align="center">
          <template slot-scope="scope">
            <span>
              {{
              returnType(scope.row)
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('title.transfer_amount')" width="90" fixed="right" align="center" prop="value">
          <template slot-scope="scope">
            <span :style="statusColor(scope.row)">
              {{statusMoney(scope.row)}}
              {{scope.row.currencyAmount/1000000000000000000}}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="total > 10"
        background
        @current-change="currentPageChange"
        :current-page="currentPage"
        :page-size="pagesize"
        layout="total,prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { searchTransaction, userlList, getrpcserver } from "@/api/interface";
import _ from "lodash";
export default {
  data() {
    return {
      envoptions: [],
      envValue: "",
      addressOptions: [],
      selectAddress: "",
      inputAddress: "",
      tableData: [],
      currentPage: 1,
      pagesize: 10,
      total: 0,
      statusAddress: "",
      loading: false,
      browserUrl: "",
      myCurrentPage: 1,
      orderType: '',
      beginRows: 1,
    };
  },
  
  async created() {
    await this.getrpcservers();
    await this.getData();

    console.log(11111);
  },
  methods: {
    statusColor(val) {
      if (val.status) {
        if (val.fromAddress == this.statusAddress) {
          return { color: "red" };
        } else {
          return { color: "green" };
        }
      } else {
        return { color: "black" };
      }
    },
    statusMoney(val) {
      if (val.status) {
        if (val.fromAddress == this.statusAddress) {
          return "-";
        } else {
          return "+";
        }
      } else {
        return "";
      }
    },
    rpcChange(val) {
      this.envoptions.forEach(v => {
        if (v.rpcUrl == val) {
          this.browserUrl = v.browserUrl;
        }
      });
      this.getTableData(this.inputAddress || this.selectAddress);
    },
    searchAddress() {
      this. currentPage = 1,
      this.searchTransactions();
      console.log(this.selectAddress, 2222);
    },
    getrpcservers() {
      getrpcserver().then(res => {
        this.envoptions = res.data;
        this.envValue = _.get(res, "data[0].rpcUrl", "");
        this.browserUrl = _.get(res, "data[0].browserUrl", "");
      });
    },
    getData() {
      //获取用户列表
      let data = {
        userContractId: "",
        address: "",
        page: 1,
        rows: 9999
      };
      userlList(data).then(res => {
        this.addressOptions = res.data.data;
        this.selectAddress = this.addressOptions[0].address;
        this.getTableData(this.addressOptions[0].address);
      });
      //首次拉取表格数据
    },
    //查询地址
    searchTransactions() {
      if (this.inputAddress == "") {
        this.getTableData(this.selectAddress);
        this.statusAddress = this.selectAddress;
      } else {
        if (this.inputAddress.length < 42) {
          this.$message.error(this.$t('title.Please_enter_the_correct_address'));
        } else {
          this.getTableData(this.inputAddress);
          this.statusAddress = this.inputAddress;
        }
      }
    },
    //请求表格数据
    getTableData(address) {
      this.loading = true;
      const data = {
        address,
        page: this.currentPage,
        rows: 60
      };
      console.log(this.browserUrl, 91991991);
      searchTransaction(data, this.browserUrl).then(res => {
        this.tableData = _.get(res.data, "data", []);
        this.total = _.get(res.data, "total", 0);
        this.loading = false;
      });
    },
    returnType(row) {
      if (row.childTypeName) {
        return row.childTypeName == "table.token_prizes"
          ? this.$t('title.Token_award')
          : row.childTypeName == "select.contract_issued"
          ? this.$t('title.Contract_release')
          : row.childTypeName == "select.tcommon_contract_tradingoken_prizes"
          ? this.$t('title.Ordinary_contract_transaction')
          : row.childTypeName == "select.poc_lock"
          ? this.$t('title.PoC_lock')
          : row.childTypeName == "select.poc_prizes"
          ? this.$t('title.PoC_awards')
          : row.childTypeName == "select.poc_redemption"
          ? this.$t('title.PoC_redemption')
          : row.childTypeName == "select.pos_award"
          ? this.$t('title.PoS_award')
          : row.childTypeName == "select.pos_lock"
          ? this.$t('title.PoS_lock')
          : row.childTypeName == "select.pos_prizes"
          ? this.$t('title.PoS_award')
          : row.childTypeName == "select.transfer_transaction"
          ? this.$t('title.Transfer_transaction')
          : row.childTypeName == "select.across_chain_trading_withdrawal"
          ? this.$t('title.Cross_chain_transaction_withdrawal')
          : row.childTypeName == "select.across_chain_trading_deposit"
          ? this.$t('title.Cross_chain_transaction_deposit')
          : row.childTypeName == "select.across_chain_trading_repeal"
          ? this.$t('title.Cross_chain_transaction_cancellation')
          : "";
      } else {
        return row.parentTypeName == "select.contract_trading"
          ? this.$t('title.Contract_transaction')
          : row.parentTypeName == "select.within_chain_trading"
          ? this.$t('title.In-chain_transactions')
          : row.parentTypeName == "select.across_chain_trading"
          ? this.$t('title.Cross_chain_transaction')
          : "";
      }
    },
    /*page切换  待优化*/
      currentPageChange(e) {
        this.currentPage = e
        //点击第一页，并且是从倒序(点击过最后一页)的页面回点第一页
        if(e == 1 && this.orderType == 1) {
          this.orderType = 0
          this.getTableData(this.statusAddress)
        }
        //当点击最后一页的时候(变成倒序的了)
        if(e == Math.ceil(this.total / 10)) {
          this.orderType = 1
          this.beginRows = this.total % 10
          //把最后一页变成第一页，倒数第二页是第二页，以此类推
          this.myCurrentPage = Math.ceil(this.total / 10) - this.currentPage + 1
          this.tableData = []
           const data = {
            orderType: this.orderType,
            timeStamp: "",
            address: this.statusAddress,
            page: this.myCurrentPage,
            rows: 60
          };
          console.log(this.browserUrl, 91991991);
          searchTransaction(data, this.browserUrl).then(res => {
            this.tableData = _.get(res.data, "data", []);
            this.total = _.get(res.data, "total", 0);
            
          });
         
        }
        //正序，从前往后点击
        if(this.orderType != 1) {
          if(this.tableData.length - this.currentPage * 10 < 50) {
              const data = {
                timeStamp: this.tableData[this.tableData.length-1].timeStamp,
                address: this.statusAddress,
                page: this.currentPage,
                rows: 50
              };
           searchTransaction(data, this.browserUrl).then(res => {
            this.tableData = [...this.tableData, ...res.data.data];
            this.total = _.get(res.data, "total", 0);
          
          });
            
          }
        }
        //倒序，从后往前点击
        if(this.orderType == 1) {
          this.beginRows = this.total % 10
          this.myCurrentPage = Math.ceil(this.total / 10) - this.currentPage + 1
          if(this.tableData.length - this.myCurrentPage * 10 < 50) {
            let data = {
              timeStamp: this.tableData[0] && this.tableData[this.tableData.length-1].timeStamp,
              address: this.statusAddress,
              page: this.myCurrentPage,
              pagesize: 50
            }
            tradingList(data).then(res => {
              this.tableData = [...this.tableData, ...res.data.data]
              this.total = res.data.total
            })
            
          }
        }
      },
  }
};
</script>
<style scoped lang="scss">
.comm_transaction_search {
  width: 100%;
  .transaction_search {
    display: flex;
    flex-wrap: wrap;
    .transaction_search_item {
      margin: 5px;
      display: flex;
      align-items: center;
      span {
        margin-right: 20px;
      }
      button {
        margin-left: 20px;
      }
    }
  }
  .transaction_table {
  }
}
</style>